import React, { Component } from 'react'
import PropTypes from 'prop-types'

import pluralize from 'pluralize'
import { Card, Icon, Image, List, Popup } from 'semantic-ui-react'
import { Link } from 'react-router'

import CardProperty from 'Components/CardProperty'

import * as styles from './styles'
import { SERVER_URL } from 'Global/constants'

class SearchCard extends Component {
  static propTypes = {
    deleteSearch: PropTypes.func.isRequired,
    search: PropTypes.object.isRequired,
  }

  handleDelete = () => {
    const { deleteSearch, search } = this.props

    deleteSearch(search.id)
  }

  render() {
    const { search } = this.props

    return (
      <Card color="blue">
        <Link
          to={{
            pathname: `/search`,
            query: { params: JSON.stringify(search.params) },
          }}
        >
          <Image src={`${SERVER_URL}/static/grids/${search.grid}`} />
        </Link>
        <Card.Content>
          <Card.Meta>
            <span className="date">{search.createdAt.slice(0, 10)}</span>
          </Card.Meta>

          <Card.Header>
            <Link
              to={{
                pathname: `/search`,
                query: { params: JSON.stringify(search.params) },
              }}
              style={styles.link}
            >
              <span>{search.name}</span>
            </Link>
          </Card.Header>
        </Card.Content>

        <Card.Content extra>
          <List>
            <CardProperty icon="search" popUpContent="Number of results">
              {`${search.rugs} ${pluralize('rug', search.rugs)}`}
            </CardProperty>
          </List>
        </Card.Content>

        <Card.Content extra>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a onClick={this.handleDelete}>
            <Popup content={'Delete Search'} size="mini" trigger={<Icon name="trash" fitted />} />
            &nbsp; Delete
          </a>
        </Card.Content>
      </Card>
    )
  }
}

export default SearchCard
